module.exports = __webpack_public_path__ + "static/media/_south-ossetia.a34d6bc8.png";